// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import LaborStatsButtonGroup from './labor-stats-button-group';

const LaborStatsSearchCriteria = props =>
    <div className='labor-stats-search-criteria'>
        <div className='part-number-criteria'>
            <LabeledCriteria
                className='part-number-criteria'
                isRequired={true}
                label='ENTER_A_PART_NUMBER'
                onInputChange={props.onPartNumberSearch}
                placeholder='PART_NUMBER'
                type='text'
                value={props.partNumber}
            />
        </div>
        <LaborStatsButtonGroup
            canExport={props.canExport}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onDownloadToExcel}
            onPartSearchExecute={props.onPartSearchExecute}
            partNumber={props.partNumber}
        />
    </div>;

LaborStatsSearchCriteria.displayName = 'LaborStatsSearchCriteria';
LaborStatsSearchCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDownloadToExcel: PropTypes.func.isRequired,
    onPartNumberSearch: PropTypes.func.isRequired,
    onPartSearchExecute: PropTypes.func.isRequired,
    partNumber: PropTypes.string.isRequired
};

export default LaborStatsSearchCriteria;



// WEBPACK FOOTER //
// ./src/reports/labor-stats/components/labor-stats-search-criteria.js